import React from 'react'

const SliderContent = ({activeIndex, sliderImage}) => {
  return (
    <section>
        {sliderImage.map((slide, index) => {
            return <div
                key={index}
                className={index === activeIndex ? "slider active" : "inactive"} 
            >
                {!!slide && slide.includes('.pdf') ? (
                        <object
                        data={slide}
                        type="application/pdf"
                        width="100%"
                        height="100%"
                    >
                        <p>Your browser does not support PDFs. <a href={slide}>Download the PDF</a>.</p>
                    </object>
                ) : (
                    <img
                        src={slide}
                        className="slide-image"
                        alt="selectedDocument"
                    />
                )}
            </div>
        })}
    </section>
  )
}

export default SliderContent
